var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "preview-sp",
    { staticClass: "pega-sp-print-area" },
    [
      _c("interview-preview-detail-sp", {
        attrs: { interview: _vm.interview },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }